export function sendError(error) {
  if (error.status === 301 || error.status === 404) throw error;
  throw new Error(error.data?.error?.message || error.data?.message || error.message || error);
}